import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getTaskPriorities } from "../../actions/userActions/taskPriorityAction";
import Loader from "../subComponents/Loader";
import Search from "../subComponents/search/Search";
import AddButton from "../subComponents/buttons/AddButton";
import { IconButton, Tooltip } from "@mui/material";
import Pagination from '../paginatioin/pagination';
import EditButton from "../subComponents/buttons/EditButton";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import SearchInput from "../subComponents/search/SearchInput";
import Heading6Regular from "../designSystem/Heading6Regular";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import AddTaskPriorities from "./AddTaskPriorities";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";
function TaskPriorities() {
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1)
  const [previousQuery, setPreviousQuery] = useState("");
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [taskprioritydata, settaskprioritydata] = useState([]);


  const dispatch = useDispatch();
  const history = useHistory();


  const taskPriorities = useSelector(
    (state) => state.task_priorities_reducer.taskPriorities
  );
  const firstPage = 1;
  const taskPrioritiesData = taskPriorities && taskPriorities.result;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalItems = taskPriorities?.totalCount || 0;
  const totalPages = taskPriorities?.totalPages || 0;
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));

  const isLoading = useSelector(
    (state) => state.task_priorities_reducer.isTaskPriorityLoading
  );

  useEffect(() => {
    const pageNumber = currentPage;

    if (query !== previousQuery) {
      setCurrentPage(1);
    }
    dispatch(getTaskPriorities(pageNumber, itemsPerPage, query));
    setPreviousQuery(query);

  }, [currentPage, query]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    history.push(`?page=${page}&search=${query}`);
  };

  useEffect(() => {
    const TaskPrioritiesData = taskPrioritiesData?.map((taskPriority) => ({
      ...taskPriority,
      status: (
        <span className={taskPriority.active ? "status-badge-active" : "status-badge-inactive"}>
          {taskPriority.active ? "Active" : "Inactive"}
        </span>
      ),
      colorDisplay: (
        <span
          style={{
            height: "20px",
            width: "20px",
            backgroundColor: taskPriority.color,
            display: "inline-block",
          }}
        ></span>
      ),
    }));
    settaskprioritydata(TaskPrioritiesData);
  }, [taskPriorities]);
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
    { label: `${t("color")}`, accessor: "colorDisplay" },
    { label: `${t("status")}`, accessor: "status" },
  ];
  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getTaskPriorities(pageNumber, value, query));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleAddTaskPriorityClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditTaskPriority = (row) => {
    setEditData({
      ...row,
      color: row.color, // Use the raw hex color, not the `colorDisplay` element
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
    dispatch(getTaskPriorities(currentPage, itemsPerPage, query));
    setShowModal(false);
  };
  const actions = [
    {
      label: 'Edit Task Priority',
      icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
      permission: 'CanUpdateTaskPriority',
      handler: handleEditTaskPriority,
    },
  ];

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1);
  };
  return (
    <>
    <div>
      <LoadingOverlay isVisible={isLoading} />
      <div className="main-container">
       <div className="content-wrapper">
          <div className="pagination">
            <SearchInput
              placeholder="Search"
              onChange={handleSearchChange}
              value={query}
            />
            <div className="flex-align-center">
              <div className="items-per-page-container">
                <ItemsPerPageSelector
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                />
              </div>
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />

              {permissions && permissions.includes("CanAddTaskPriority") && (
                <CustomButton text={t("addNew")} onClick={handleAddTaskPriorityClick} />
              )}
            </div>
          </div>
        </div>
        <DynamicTable
          data={taskprioritydata}
          columns={columns}
          permissions={permissions}
          actions={actions}
          thIcon={thIcon}
          showPagination={totalItems > 0}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
        {showModal && (
          <AddTaskPriorities
            onClose={handleCloseModal}
            editData={editData}
            onSave={handleSaveData}
          />
        )}
      </div> 
      </div> 

    </>
  );
}

export default TaskPriorities;
